<script setup>
import { computed } from 'vue';
import { default as t } from '../../translations/translationStrings';
import { ORGANIC_FARMING_ID } from '../../utils/constants';
import ResponsiveImage from '../elements/ResponsiveImage';
import SustainabilityPie from '../elements/SustainabilityPie';

// Props.
const props = defineProps({
  product: {
    required: true,
    type: Object,
    default: () => {},
  },
});

// Computed.
const isOrganic = computed(() => {
  return props.product.targetAreas?.includes(ORGANIC_FARMING_ID);
});

// The s12y badge is shown when at least one of the following is truthy.
const hasS12yData = computed(() => {
  return (
    props.product.sustainableApplication.greenhouseGasEfficiency ||
    props.product.sustainableApplication.waterEfficiency ||
    props.product.sustainableApplication.nutrientUseEfficiency
  );
});
</script>

<template>
  <li class="product">
    <a :href="product.url" class="product__link">
      <div class="product__badges">
        <span
          class="product-badge product-badge--round product-badge--organic"
          v-if="isOrganic">
          <span></span>
        </span>
        <span class="product-badge product-badge--round" v-if="hasS12yData">
          <SustainabilityPie :s12y-data="product.sustainableApplication" />
        </span>
        <span
          class="product-badge product-badge--round"
          v-if="product.sustainableProduction.co2Reduction">
          <img
            :src="`/${require('../../../images/s12y-icons/icon-co2Reduction.svg')}`"
            alt="" />
        </span>
      </div>
      <div class="product__img-wrapper">
        <ResponsiveImage :images="product.images" />
        <!-- the 'New' badge -->
        <span class="product-badge product-badge--new" v-if="product.isNew">
          {{ t.new }}
        </span>
      </div>
      <div class="product__name" v-html="product.name"></div>
    </a>
  </li>
</template>
